export enum SleepValues {
  CreateOrEditExp = 5000,
  CreateOrEditGig = 5000,
  CreateOrEditForceUpdate = 5000,
  CreateOrEditSession = 5000,
  CreateOrEditLearner = 5000,
  CreateNotification = 5000,
  CreateOrEditGiftCard = 5000,
  CreateOrEditCoach = 5000,
  CreateOrEditBanner = 5000,
  CreateOrEditCollection = 5000,

  SortBanners = 5000,
}
